import { useMatch } from 'react-router-dom'

import { INBOX_FULL_ROUTE_PATHS } from '../routes'

export default function useConversationId() {
  const detailsRouteMatch = useMatch(INBOX_FULL_ROUTE_PATHS.CONVERSATION_DETAILS)
  const conversationRouteMatch = useMatch(INBOX_FULL_ROUTE_PATHS.CONVERSATION)

  return detailsRouteMatch?.params.id ?? conversationRouteMatch?.params.id
}
